module.exports = __webpack_public_path__ + "static/media/yesplz-logo.0a565627.svg";